import axios from "axios";

// Admin session for the dashboards (reports list, reviews, campaigns).
// The backend checks every admin route; this only carries the token and
// sends the admin back to the login page when the session is over.
const TOKEN_KEY = "selletrust_admin_token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setToken = (token) => {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    // Private mode or blocked storage: the session lasts until the page reloads.
  }
};

export const clearToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    // Nothing stored.
  }
};

export const isAdminSession = () => Boolean(getToken());

export const loginPath = (next) =>
  next && next !== "/login" ? `/login?next=${encodeURIComponent(next)}` : "/login";

const goToLogin = () => {
  clearToken();
  if (!window.location.pathname.startsWith("/login")) {
    window.location.assign(loginPath(window.location.pathname));
  }
};

export const adminFetch = async (url, options = {}) => {
  const token = getToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await fetch(url, { ...options, headers });
  if (response.status === 401) goToLogin();
  return response;
};

let axiosReady = false;

export const installAdminAuth = () => {
  if (axiosReady) return;
  axiosReady = true;
  axios.interceptors.request.use((config) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) goToLogin();
      return Promise.reject(error);
    }
  );
};
